(function () {
  'use strict';
  const id = value => /^[1-9]\d*$/.test(String(value)) && Number.isSafeInteger(Number(value)) ? String(value) : '';
  const clean = (value, max = 220) => typeof value === 'string' ? value.replace(/[<>\u0000-\u001f\u007f]/g, '').replace(/\s+/g, ' ').trim().slice(0, max) : '';
  const validVin = value => !value || /^[A-HJ-NPR-Z0-9]{17}$/.test(value);
  function normalizeVehicle(value) {
    if (!value || !Number.isInteger(Number(value.year)) || Number(value.year) < 1900 || Number(value.year) > new Date().getFullYear() + 1) return null;
    const result = { year: Number(value.year), make: clean(value.make, 100), model: clean(value.model, 140), engine: clean(value.engine), fuel: clean(value.fuel, 80), vin: clean(value.vin, 30).toUpperCase(), source: 'manual', verified: false };
    if (!result.make || !result.model || !result.engine || !validVin(result.vin)) return null;
    if (value.verified === true && value.market === 'USA' && id(value.source_make_id) && id(value.source_model_id) && id(value.source_type_id)) {
      try {
        const url = new URL(value.source_url);
        if (url.protocol !== 'https:' || !['www.liqui-moly.com', 'liqui-moly.com'].includes(url.hostname)) return null;
        result.source_url = url.href;
      } catch { return null; }
      if (value.engine_details && typeof value.engine_details === 'object') {
        const details = value.engine_details;
        result.engine_details = { type_name: clean(details.type_name, 140), code: clean(details.code, 80), displacement_cc: Number.isFinite(Number(details.displacement_cc)) && Number(details.displacement_cc) > 0 ? Number(details.displacement_cc) : null, power_kw: Number.isFinite(Number(details.power_kw)) && Number(details.power_kw) > 0 ? Number(details.power_kw) : null, drive_type: clean(details.drive_type, 30) };
      }
      Object.assign(result, { source: 'guide', verified: true, market: 'USA', source_make_id: id(value.source_make_id), source_model_id: id(value.source_model_id), source_type_id: id(value.source_type_id) });
    }
    return result;
  }
  function vehicleKey(vehicle) {
    const row = normalizeVehicle(vehicle);
    return row ? JSON.stringify(row) : '';
  }
  function electricVehicle(vehicle) {
    if (!vehicle) return false;
    const values = [vehicle.fuel, ...String(vehicle.engine || '').split('·')].map(value => clean(value).toLowerCase());
    if (values.some(value => /hybrid|plug[- ]?in|phev|petrol|diesel|gasoline/.test(value))) return false;
    return values.some(value => /^(?:electric|electric motor|bev|battery electric|battery electric vehicle|fully electric)$/.test(value));
  }
  function buildVehicleProperties(vehicle, options = {}) {
    const row = normalizeVehicle(vehicle);
    if (!row) return {};
    const properties = { Vehicle: `${row.year} ${row.make} ${row.model}`, Engine: row.engine, 'Vehicle details': row.source === 'guide' ? 'Selected in LIQUI MOLY guide' : 'Customer entered; team confirmation required', _lm_vehicle_source: row.source, _lm_vehicle_year: String(row.year), _lm_vehicle_make: row.make, _lm_vehicle_model: row.model, _lm_vehicle_engine: row.engine };
    if (row.vin) properties.VIN = row.vin;
    if (row.source === 'guide') Object.assign(properties, { _lm_make: row.source_make_id, _lm_model: row.source_model_id, _lm_type: row.source_type_id, _lm_market: row.market });
    if (options.filter) Object.assign(properties, { 'Filter fitment': 'Our team confirms filter fitment before shipping', _lm_filter_service: 'fitment_confirmation_required' });
    if (options.filterRequested) properties['Oil filter'] = 'Requested as a separate cart item';
    if (options.oilMatch) { properties['LIQUI MOLY guide'] = options.oilMatch === 'listed' && row.source === 'guide' ? 'Selected size is listed' : 'Product compatibility not verified'; properties['Oil fitment'] = options.oilMatch === 'listed' && row.source === 'guide' ? 'Manufacturer match' : 'Needs team confirmation'; }
    return properties;
  }
  function hasVehicleFilter(cart, config, vehicle) {
    const properties = buildVehicleProperties(vehicle, { filter: true });
    if (!properties.Vehicle) return false;
    return (cart?.items || []).some(line => id(line.variant_id) === id(config?.variantId) && Number(line.quantity) > 0 && line.properties?._lm_filter_service === 'fitment_confirmation_required' && line.properties.Vehicle === properties.Vehicle && line.properties.Engine === properties.Engine && (line.properties.VIN || '') === (properties.VIN || ''));
  }
  function filterVariant(payload, config, cart) {
    if (!payload || id(payload.id) !== id(config.productId) || payload.handle !== config.handle || payload.currency !== config.currency || payload.giftCard || payload.requiresSellingPlan || !Array.isArray(payload.variants)) throw new Error('FILTER_UNAVAILABLE');
    const matches = payload.variants.filter(row => id(row.id) === id(config.variantId) && row.sku === config.sku);
    if (matches.length !== 1) throw new Error('FILTER_UNAVAILABLE');
    const row = matches[0], rule = row.quantity_rule;
    const existing = (cart?.items || []).filter(item => id(item.variant_id) === id(row.id)).reduce((sum, item) => sum + Number(item.quantity || 0), 0);
    if (row.available !== true || row.requiresSellingPlan || row.price !== 1000 || !rule || rule.min !== 1 || rule.increment !== 1 || (rule.max !== null && (!Number.isSafeInteger(rule.max) || existing + 1 > rule.max))) throw new Error('FILTER_UNAVAILABLE');
    if (row.inventory_management && row.inventory_policy === 'deny' && (!Number.isSafeInteger(row.inventory_quantity) || existing + 1 > row.inventory_quantity)) throw new Error('FILTER_UNAVAILABLE');
    return row;
  }
  async function nativeProduct(config, signal) {
    if (!/^[a-z0-9][a-z0-9-]*$/.test(config.handle || '') || !/^\/(?!\/)[a-zA-Z0-9/-]*$/.test(config.root || '') || signal?.aborted) throw new Error('PRODUCT_UNAVAILABLE');
    const request = new AbortController(), cancel = () => request.abort();
    signal?.addEventListener('abort', cancel, { once: true });
    const timer = setTimeout(cancel, 12000);
    try {
      const response = await fetch(config.root + 'products/' + config.handle + '?sections=sac-liqui-moly-filter-data', { credentials: 'same-origin', cache: 'no-store', signal: request.signal });
      if (!response.ok) throw new Error('PRODUCT_UNAVAILABLE');
      const sections = await response.json(), html = sections?.['sac-liqui-moly-filter-data'];
      if (typeof html !== 'string' || html.length > 500000) throw new Error('PRODUCT_UNAVAILABLE');
      const nodes = new DOMParser().parseFromString(html, 'text/html').querySelectorAll('script[data-lm-filter-product-json]');
      if (nodes.length !== 1) throw new Error('PRODUCT_UNAVAILABLE');
      return JSON.parse(nodes[0].textContent);
    } finally { clearTimeout(timer); signal?.removeEventListener('abort', cancel); }
  }
  class Service extends (typeof HTMLElement === 'undefined' ? class {} : HTMLElement) {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController(); this.guideVehicle = null; this.busy = false;
      try { this.config = JSON.parse(this.querySelector('[data-lm-service-config]').textContent); } catch { return; }
      this.mode = this.dataset.mode || 'immediate';
      this.addEventListener('change', event => { if (event.target.matches('[data-lm-service-manual],[data-lm-service-check],[data-lm-service-input]')) this.changed(); }, { signal: this.controller.signal });
      this.addEventListener('input', event => { if (event.target.matches('[data-lm-service-input]')) this.changed(); }, { signal: this.controller.signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-lm-service-add]')) this.add();
        if (event.target.closest('[data-lm-service-review]')) this.review();
      }, { signal: this.controller.signal });
      document.addEventListener('sac:liqui-cart:state', () => this.render(), { signal: this.controller.signal });
      this.render();
    }
    disconnectedCallback() { this.finishFilterOffer?.('cancel'); this.controller?.abort(); this.controller = null; }
    t(key) { return this.config?.strings?.[key] || key; }
    manual() { return this.querySelector('[data-lm-service-manual]')?.checked === true; }
    input(name) { return this.querySelector(`[data-lm-service-input="${name}"]`); }
    getVehicle() {
      const vin = this.input('vin')?.value || '';
      if (!this.manual() && this.guideVehicle) return normalizeVehicle({ ...this.guideVehicle, vin });
      if (!this.manual()) return null;
      return normalizeVehicle(Object.fromEntries(['year', 'make', 'model', 'engine', 'vin'].map(name => [name, this.input(name)?.value || ''])));
    }
    setVehicle(vehicle) {
      if (!this.controller) this.connectedCallback();
      const normalized = normalizeVehicle(vehicle);
      if (vehicleKey(this.guideVehicle) === vehicleKey(normalized)) return;
      this.guideVehicle = normalized ? { ...vehicle } : null;
      if (this.input('vin')) this.input('vin').value = '';
      if (normalized) { const manual = this.querySelector('[data-lm-service-manual]'); if (manual) manual.checked = false; }
      const check = this.querySelector('[data-lm-service-check]'); if (check) check.checked = false;
      this.changed();
    }
    clearVehicle() {
      this.guideVehicle = null;
      const manual = this.querySelector('[data-lm-service-manual]'); if (manual) manual.checked = false;
      if (this.input('vin')) this.input('vin').value = '';
      const check = this.querySelector('[data-lm-service-check]'); if (check) check.checked = false;
      this.changed();
    }
    wantsFilter() { return this.mode === 'required' || this.mode === 'immediate' || this.querySelector('[data-lm-service-check]')?.checked === true; }
    changed() {
      if (!this.offerCommitting) this.finishFilterOffer?.('cancel');
      this.status(''); this.render();
      this.dispatchEvent(new CustomEvent('sac:liqui-vehicle:changed', { bubbles: true, detail: { vehicle: this.getVehicle(), filterRequested: this.wantsFilter() } }));
    }
    status(key) { const node = this.querySelector('[data-lm-service-status]'); if (node) node.textContent = key ? this.t(key) : ''; }
    validate() {
      if (!validVin(clean(this.input('vin')?.value || '', 30).toUpperCase())) { this.status('service_vin_invalid'); this.input('vin')?.focus(); return false; }
      if (electricVehicle(this.getVehicle())) { this.status('service_electric'); return false; }
      if (this.getVehicle()) return true;
      this.status('service_vehicle_needed');
      const manual = this.querySelector('[data-lm-service-manual]'); if (manual && !manual.checked) { manual.checked = true; this.render(); }
      const missing = ['year', 'make', 'model', 'engine'].find(name => !clean(this.input(name)?.value || '')) || 'year'; this.input(missing)?.focus();
      return false;
    }
    async getLineItem(cart) {
      if (!this.validate()) throw new Error('VEHICLE_REQUIRED');
      const vehicle = this.getVehicle(), key = vehicleKey(vehicle), config = this.config;
      if (!id(config?.productId) || !id(config?.variantId) || config.handle !== 'sac-city-vehicle-matched-oil-filter' || config.sku !== 'SAC-VEHICLE-OIL-FILTER' || !/^\/(?!\/)[a-zA-Z0-9/-]*$/.test(config.root)) throw new Error('FILTER_UNAVAILABLE');
      const variant = filterVariant(await nativeProduct(config, this.controller.signal), config, cart);
      if (key !== vehicleKey(this.getVehicle()) || !this.isConnected) throw new Error('VEHICLE_CHANGED');
      return { id: id(variant.id), quantity: 1, properties: buildVehicleProperties(vehicle, { filter: true }) };
    }
    async requestOilFilter({ cart, oilTitle, oilMatched = false } = {}) {
      if (this.offerPromise) return this.offerPromise;
      const vehicle = this.getVehicle(), initialKey = vehicleKey(vehicle), decisionKey = initialKey || 'unselected';
      const dialog = this.querySelector('[data-lm-filter-offer]');
      if (!dialog?.showModal || !this.controller || electricVehicle(vehicle) || hasVehicleFilter(cart, this.config, vehicle) || this.offerDeclined?.has(decisionKey)) return { action: 'without' };
      const active = document.activeElement, signal = this.controller.signal;
      this.offerDeclined ||= new Set();
      let resolve;
      this.offerPromise = new Promise(done => { resolve = done; });
      const pending = this.offerPromise, events = new AbortController();
      const finish = (action, oilAcknowledged = false, remember = false) => {
        if (this.offerPromise !== pending) return;
        events.abort();
        if (remember) this.offerDeclined.add(decisionKey);
        if (dialog.open) dialog.close();
        for (const input of dialog.querySelectorAll('[data-lm-offer-input]')) input.disabled = true;
        this.offerPromise = null; this.finishFilterOffer = null;
        if (active?.isConnected) active.focus({ preventScroll: true });
        resolve({ action, oilAcknowledged });
      };
      this.finishFilterOffer = finish;
      signal.addEventListener('abort', () => finish('cancel'), { once: true, signal: events.signal });
      try {
        filterVariant(await nativeProduct(this.config, signal), this.config, cart);
        if (this.offerPromise !== pending) return pending;
        if (signal.aborted || !this.isConnected || initialKey !== vehicleKey(this.getVehicle())) { finish('cancel'); return pending; }
        const title = dialog.querySelector('[data-lm-offer-oil]'); if (title) title.textContent = clean(oilTitle);
        const selected = dialog.querySelector('[data-lm-offer-vehicle]');
        if (selected) { selected.hidden = !vehicle; selected.textContent = vehicle ? `${vehicle.year} ${vehicle.make} ${vehicle.model} · ${vehicle.engine}` : ''; }
        const fields = dialog.querySelector('[data-lm-offer-fields]');
        if (fields) fields.hidden = !!vehicle;
        for (const input of dialog.querySelectorAll('[data-lm-offer-input]')) { input.value = ''; input.disabled = !!vehicle; }
        const acknowledgment = dialog.querySelector('[data-lm-offer-ack]'), ackWrap = dialog.querySelector('[data-lm-offer-ack-wrap]');
        const needsAcknowledgment = !vehicle || vehicle.source === 'manual' || !oilMatched;
        if (acknowledgment) acknowledgment.checked = false;
        if (ackWrap) ackWrap.hidden = !needsAcknowledgment;
        const error = dialog.querySelector('[data-lm-offer-error]'); if (error) error.textContent = '';
        const accept = () => {
          if (initialKey !== vehicleKey(this.getVehicle()) || signal.aborted) { finish('cancel'); return; }
          let acceptedVehicle = vehicle;
          if (!acceptedVehicle) {
            const inputs = [...dialog.querySelectorAll('[data-lm-offer-input]')];
            if (inputs.some(input => !input.reportValidity())) return;
            acceptedVehicle = normalizeVehicle(Object.fromEntries(inputs.map(input => [input.dataset.lmOfferInput, input.value])));
          }
          if (!acceptedVehicle || electricVehicle(acceptedVehicle)) { if (error) error.textContent = this.t(acceptedVehicle ? 'service_electric' : 'service_vehicle_needed'); return; }
          if (needsAcknowledgment && !acknowledgment?.checked) { if (error) error.textContent = this.t('offer_ack_needed'); acknowledgment?.focus(); return; }
          this.offerCommitting = true;
          try {
            if (!vehicle) {
              const manual = this.querySelector('[data-lm-service-manual]'); if (manual) manual.checked = true;
              for (const name of ['year', 'make', 'model', 'engine', 'vin']) if (this.input(name)) this.input(name).value = acceptedVehicle[name] || '';
            }
            const check = this.querySelector('[data-lm-service-check]'); if (check) check.checked = true;
            this.changed();
          } finally { this.offerCommitting = false; }
          if (vehicleKey(acceptedVehicle) !== vehicleKey(this.getVehicle())) { finish('cancel'); return; }
          finish('with', needsAcknowledgment);
        };
        dialog.addEventListener('click', event => {
          if (event.target.closest('[data-lm-offer-accept]')) accept();
          else if (event.target.closest('[data-lm-offer-skip]')) finish('without', false, true);
          else if (event.target.closest('[data-lm-offer-close]') || event.target === dialog) finish('cancel');
        }, { signal: events.signal });
        dialog.addEventListener('cancel', event => { event.preventDefault(); finish('cancel'); }, { signal: events.signal });
        dialog.addEventListener('close', () => finish('cancel'), { signal: events.signal });
        dialog.addEventListener('keydown', event => { if (event.key === 'Enter' && event.target.matches('[data-lm-offer-input]')) { event.preventDefault(); event.stopPropagation(); accept(); } }, { signal: events.signal });
        dialog.showModal();
        dialog.querySelector('[data-lm-offer-skip]')?.focus();
      } catch {
        finish(signal.aborted ? 'cancel' : 'without');
      }
      return pending;
    }
    async add() {
      if (this.busy || !this.validate() || !window.SacLmCart || window.SacLmCart.state?.uncertain) return;
      this.busy = true; this.status('service_busy'); this.render();
      try {
        window.SacLmCart.configure({ root: this.config.root, currency: this.config.currency });
        await window.SacLmCart.add({ source: 'lm-filter', prepare: async cart => [await this.getLineItem(cart)] });
        this.status('service_added');
      } catch (error) { this.status(error.uncertain ? 'service_uncertain' : error.message === 'VEHICLE_REQUIRED' ? 'service_vehicle_needed' : 'service_unavailable'); }
      finally { this.busy = false; this.render(); }
    }
    async review() {
      if (!window.SacLmCart || this.busy) return;
      try { await window.SacLmCart.acknowledge({ source: 'lm-filter-review' }); this.status('service_reviewed'); } catch { this.status('service_uncertain'); }
      this.render();
    }
    render() {
      if (!this.config) return;
      const manual = this.manual(), vehicle = this.getVehicle();
      const fields = this.querySelector('[data-lm-service-manual-fields]'); if (fields) { fields.hidden = !manual; for (const field of fields.querySelectorAll('input')) field.disabled = !manual; }
      const selected = this.querySelector('[data-lm-service-vehicle]'); if (selected) { selected.hidden = !vehicle; selected.textContent = vehicle ? `${vehicle.year} ${vehicle.make} ${vehicle.model} · ${vehicle.engine}` : ''; }
      const electric = electricVehicle(vehicle), blocked = this.busy || window.SacLmCart?.state?.busy || window.SacLmCart?.state?.uncertain || electric;
      const button = this.querySelector('[data-lm-service-add]'); if (button) button.disabled = !!blocked || !id(this.config.variantId);
      const check = this.querySelector('[data-lm-service-check]'); if (check) check.disabled = !!blocked || !id(this.config.variantId);
      if (electric) { if (check) check.checked = false; this.status('service_electric'); }
      const review = this.querySelector('[data-lm-service-review]'); if (review) review.hidden = !window.SacLmCart?.state?.uncertain;
    }
  }
  const api = { normalizeVehicle, vehicleKey, buildVehicleProperties, hasVehicleFilter, filterVariant, electricVehicle, nativeProduct, Service };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window !== 'undefined') { window.SacLmService = api; if (!customElements.get('sac-liqui-service')) customElements.define('sac-liqui-service', Service); }
}());
